// BS Collapse
import { Collapse } from "bootstrap";

let accordions = document.querySelectorAll(".accordion");

if (accordions != "undefined" && accordions != null) {
	accordions.forEach((el) => {
		let bsCollapse = new Collapse(el, {
			toggle: true,
		});
	});
}
